<template>
  <div class="PatientSearch">
    <lk-dropdown trigger="custom" :visible="visible" @on-click="onDropDownclick" ref="dropdown"
      style="width: 100%">
      <lk-input suffix="ios-search" :placeholder="placeholder" @on-change="onInputChange" v-model="value" ref='search' @on-blur='inputBlur' @on-keydown='handleSearchKey' @on-focus="onInputChange" :disabled="disabled1">

      </lk-input>
      <lk-dropdown-menu slot="list" class="searchList" v-if="options.length">

        <lk-dropdown-item  v-for="(item, index) in options" :key="index" :name='index'  :selected='index===selectedIndex' >
          <div :class="{'options':true,}" >

            <span>{{getDataFunc?item.name:item.salePrescription.patientName}}</span>
            <span>{{getDataFunc?item.phone:item.salePrescription.patientPhone}}</span>
            <!-- <span>{{item.producer}}</span> -->

          </div>

        </lk-dropdown-item>
      </lk-dropdown-menu>
      <lk-dropdown-menu slot="list" class="searchList" v-else>
       <lk-dropdown-item >
         <div class="noData">
             <span>无相关数据</span>
         </div>
       </lk-dropdown-item>
      </lk-dropdown-menu>
    </lk-dropdown>
  </div>
</template>
<script>
import sale from '../../services/sale';
import utils from '../../libs/utils';

export default {
  name: 'PatientSearch',
  props: {
    autoFocus: {
      type: Boolean,
      default: false,
    },
    selectedList: {
      type: Array,
    },
    type: {
      type: [Number, String],
    },
    placeholder: {
      type: String,
      default: '输入患者姓名、手机号搜索',
    },
    getDataFunc: {
      type: Function,
    },
    saveValue: {
      type: Boolean,
      default: false,
    },
    val: {
      type: String,
      default: '',
    },
    disabled1: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: '',
      visible: false,
      selectLoading: false,
      selectedIndex: null,
      options: [],
    };
  },
  watch: {
    val(val) {
      this.value = val;
    },
  },
  methods: {
    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        parent.$emit(...[eventName].concat(params));
      }
    },
    onInputChange() {
      this.value && (this.visible = true);
      clearTimeout(this.timer);

      let getData = this.getData;
      if (this.getDataFunc) {
        if (this.value) {
          getData = () => {
            this.getDataFunc(this.value).then((res) => {
              console.log('getDataFunc返回值为promise，resolve 返回为数组，name，phone为显示字段');
              console.log(res);

              if (res.length) {
                this.options = res;
                this.selectedIndex = 0;
              }
              this.$emit('selected', { name: this.value });
              this.$nextTick(() => {
                this.dispatch('FormItem', 'on-form-change', this.value);
              });
            }).catch((err) => {
              utils.handleError(err);
            });
          };
        } else {
          this.$emit('selected', { name: this.value });
          this.$nextTick(() => {
            this.dispatch('FormItem', 'on-form-change', this.value);
          });
          return;
        }
      }


      this.timer = setTimeout(getData, 500);
    },
    getData() {
      if (this.value) {
		    this.$store.commit('setDisableLoading', true);

        sale.getLastPrescription({
          patientMix: this.value,
          retailType: this.type,
          prescriptionId: this.$route.params.id || '',
        }).then((res) => {
          if (res.data.status === 200) {
            // res.data
            this.options = [];

            if (res.data.data && res.data.data.length && this.value) { // 控制异步查询搜索词为空展示问题
              res.data.data.forEach((item) => {
                item.saleUsageList && item.saleUsageList.forEach((subItem) => {
                  subItem.usageStartTime = null;
                });
                this.options.push(item);
              });

              this.selectedIndex = 0;
            }
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          if (!sale.axios.isCancel(err)) {
            this.$Message.error('网络连接失败');
          }
          console.log(err);
        });
      } else {
        this.options = [];
        this.visible = false;
      }
    },
    // handleClick(){}
    onDropDownclick(name) {
      if (this.selectLoading || name === 'title') {
        this.selectLoading = false;
        this.visible = false;
        this.$nextTick(() => {
          this.$refs.dropdown.currentVisible = false; // 规避iview组件不能驱动内部参数问题
        });
      } else {
        this.visible = true;

        this.selectLoading = true;

        if (!Number.isNaN(name)) {
          this.selectedIndex = name;
          this.seleced();
          this.$nextTick(() => {
            this.visible = false;
          });
        }
        setTimeout(() => {
          this.selectLoading = false;
        }, 500);
      }
    },
    inputBlur() {
      this.$nextTick(() => {
        this.visible = false;
      });
    },
    onKeydown() {
      // console.log(e);


    },
    focus() {
      this.$refs.search.focus();
    },
    seleced() {
      this.visible = false;


      const temp = utils.deepClone(this.options[this.selectedIndex]);

      if (this.saveValue) {
        this.value = temp ? temp.name : this.value;
      } else {
        this.value = '';
      }
      if (temp.salePrescription) {
        delete temp.salePrescription.id;
        delete temp.salePrescription.prescriptionNo;
        delete temp.salePrescription.prescriptionTime;
        delete temp.salePrescription.reviewerName;
        delete temp.salePrescription.allocaterName;
        delete temp.salePrescription.diseaseName;
      }
      this.$emit('selected', temp);
      this.$nextTick(() => {
        this.dispatch('FormItem', 'on-form-change', temp.name);
      });
    },


    handleSearchKey(e) {
      if (this.visible) {
        switch (e.key) {
          case 'ArrowDown':
            (this.selectedIndex < this.options.length - 1) && this.selectedIndex++;

            break;
          case 'ArrowUp': (this.selectedIndex > 0) && this.selectedIndex--;

            break;
          case 'Enter': if (this.selectedIndex !== null) {
            this.seleced(); this.$emit('on-keydown', e);
          }

            break;
          default: break;
        }
      }
      if (e.key === 'z' && e.ctrlKey) {
        this.$emit('swichKeyDown', e, 'goods0');
      }
    },

  },
  mounted() {
    this.$nextTick(() => {
      this.value = this.val;
      if (this.autoFocus) {
        this.$refs.search.focus();
      }
    });
  },

};
</script>
<style lang="less" scoped>
.searchList{
  max-height: 300px;
  overflow: auto
}
.noData{
  color: #ccc;
  cursor: default;
}
.selected{
  background: #f8f8f8
}
.options{
  // width: 660px;
  display: flex;
  align-items: center;
  font-size: 12px;
  >span{
    width: 144px;
    text-align: left;
    word-wrap: none;
    text-overflow: ellipsis;
    overflow: hidden;

  }
  >span:nth-child(2){
    width: 180px
  }
  .textOver{
    width: 100%;
    text-align: left;
    word-wrap: none;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
